// extracted by mini-css-extract-plugin
module.exports = {"chunk":"_1q3nl","empty":"i5XJW","emptyTitle":"_31t0l","emptyText":"I9bgC"};